import { render } from "./LoadingComponent.vue?vue&type=template&id=596268e4&scoped=true&ts=true&lang=html"
import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingComponent.vue?vue&type=style&index=0&id=596268e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596268e4"]])

export default __exports__